import { api } from './api';

const customerAPI = {
  getCustomerContainers: (customerId) => api.get(`/customers/${customerId}/containers`),
  getContainerTimeline: (containerNumber) => api.get(`/containers/${containerNumber}/timeline`),
  track: (containerNumber, bookingNumber) =>
    api.get('/containers/track', {
      params: {
        containerNumber,
        bookingNumber
      }
    }),
};

export default customerAPI;